import { toast } from 'react-toastify';
import { Common } from './constants';

export const showResetPasswordErrorToast = (error, t: (key: string) => string) => {
  switch (error?.name) {
    case Common.Authentication.CodeMismatchException:
    case Common.Authentication.InvalidParameterException:
      toast.error(t('forgot.toast.invalidCode'));
      break;

    case Common.Authentication.PasswordHistoryPolicyViolationException:
      toast.error(t('forgot.toast.alreadyUsedPassword'));
      break;

    case Common.Authentication.LimitExceededException:
      toast.error(t('login.toast.maximumAttempt'));
      break;

    default:
      toast.error(t('forgot.toast.error'));
      break;
  }
};
